
import Vue from "vue";
export default Vue.extend({
  name: "section-card",
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    cardIcon: {
      type: String,
      required: false,
    },
    destination: {
      type: String,
      required: false,
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
  },
});
